import { MapAddress } from "~/application/types";
import { MapAddressDTO } from "../dtos";

export function mapMapAddressDTO(data: MapAddressDTO): MapAddress {
  return {
    placeId: data.place_id,
    address: data.address,
    latitude: data.latitude,
    longitude: data.longitude,
  };
}
